import { LocalStorageClient } from 'core/infra/storage/LocalStorageClient'

import { AgnosticUserRepository } from '../infra/AgnosticUserRepository'

export function saveAgnosticUserToken(token: string) {
  const storage = new LocalStorageClient()
  const repository = new AgnosticUserRepository({ storage })

  repository.setLocalToken(token)
}
